import { useEffect, useState } from 'react';
import { FormRow } from '../components';
import styled from 'styled-components';
import { useGlobalContext } from '../context/GlobalContext';
// import sha256 from 'crypto-js/sha256';
import { useNavigate } from 'react-router-dom';
import { dummyusers } from '../utils/dummydata';

const initialState = {
  name: '',
  email: '',
  password: '',
  isMember: true,
  isAdmin: false,
};

const Register = () => {
  const navigate = useNavigate();
  const [values, setValues] = useState(initialState);
  const { isLoading, displayAlert, setupUser, user } = useGlobalContext();

  const toggleMember = () => {
    setValues({ ...values, isMember: !values.isMember });
  };

  // dynamic updating the input field corresponding to the correct input
  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    setValues({ ...values, [name]: value }); // square brackets on name = e.target.name to not make this hard coded 'name'
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const { name, email, password, isMember } = values;
    if (!email || !password || (!isMember && !name)) {
      displayAlert();
      return;
    }
    const currentUser = { name, email, password };
    // const { name, email, password, isMember } = dummyusers[0];
    // const currentUser = { name, email, password };
    if (isMember) {
      setupUser({
        currentUser,
        endPoint: 'login',
        alertText: 'Login Successful! Redirecting...',
      });
    } else {
      setupUser({
        currentUser,
        endPoint: 'register',
        alertText: 'User Created! Redirecting...',
      });
    }
  };

  useEffect(() => {
    if (user) {
      setTimeout(() => {
        navigate('/auth');
      }, 3000);
    }
  }, [user, navigate]);

  return (
    <RegisterContainer className='full-page'>
      <form className='form' onSubmit={onSubmit}>
        {/* <Logo /> */}
        <h3>{values.isMember ? 'Login' : 'Register'}</h3>
        {/* name field */}
        <FormRow
          type='text'
          name='name'
          value={values.name}
          handleChange={handleChange}
        />

        {/* email field */}
        <FormRow
          type='email'
          name='email'
          value={values.email}
          handleChange={handleChange}
        />
        {/* password field */}
        <FormRow
          type='password'
          name='password'
          value={values.password}
          handleChange={handleChange}
        />
        {/* address1 field */}
        {!values.isMember && (
          <FormRow
            type='text'
            name='address1'
            value={values.address1}
            handleChange={handleChange}
          />
        )}
        {/* address2 field */}
        {!values.isMember && (
          <FormRow
            type='text'
            name='address2'
            value={values.address2}
            handleChange={handleChange}
          />
        )}
        {/* phone field */}
        {!values.isMember && (
          <FormRow
            type='text'
            name='phone'
            value={values.phone}
            handleChange={handleChange}
          />
        )}
        <button type='submit' className='btn btn-block' disabled={isLoading}>
          {isLoading ? 'loading...' : 'submit'}
        </button>
        <p>
          {values.isMember ? 'Not a member yet?' : 'Already a member?'}
          <button type='button' onClick={toggleMember} className='member-btn'>
            {values.isMember ? 'Register' : 'Login'}
          </button>
        </p>
      </form>
    </RegisterContainer>
  );
};

const RegisterContainer = styled.section`
  display: grid;
  align-items: center;
  .logo {
    display: block;
    margin: 0 auto;
    margin-bottom: 1.38rem;
  }
  h3 {
    text-align: center;
  }
  p {
    margin: 0;
    margin-top: 1rem;
    text-align: center;
  }
  .btn {
    margin-top: 1rem;
  }
  .member-btn {
    background: transparent;
    border: transparent;
    color: var(--primary-500);
    cursor: pointer;
    letter-spacing: var(--letterSpacing);
  }
`;
export default Register;
